import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Col, Divider, Radio, Row, Space, Switch } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { selectConfig, selectConfigActionEvent, selectConfigEvent } from 'Store/pos/selector'
import { selectCurrentUser } from 'Store/user/selector'
import EventModal from 'Components/modal/EventModal'
import { LoadingView } from 'Components/modal'
import { GetConfigReq, SetConfigReq } from 'Store/pos/types'
import { getConfigAPI, setConfigAPI } from 'Store/pos/api'
import { clearEventAction } from 'Store/pos/actions'
import { MyTheme } from 'Components/common/Theme'
import { DocumentConfigKey, menuPaperSize } from 'helpers/constanst'
import { PrimaryButton } from 'Components/button'

type Props = {} & ReduxProps

const BarcodeConfig: React.FunctionComponent<Props> = props => {
  const { currentUser, actionEvent, event, configData } = props
  const dispatch = useDispatch()
  const [isEnableName, setIsEnableName] = useState(false as boolean)
  const [isEnablePrice, setIsEnablePrice] = useState(false as boolean)
  const [isEnableUom, setIsEnableUom] = useState(false as boolean)
  const [paperType, setPaperType] = useState('1' as string)
  const key = DocumentConfigKey.BARCODE

  useEffect(() => {
    onGetConfig()
  }, [])

  useEffect(() => {
    if (configData) {
      const data = configData && configData?.config_value && JSON.parse(configData?.config_value || '')
      setIsEnableName(data?.enableName || false)
      setIsEnablePrice(data?.enablePrice || false)
      setIsEnableUom(data?.enableUom || false)
      setPaperType(data?.paperType || 1)
    }
  }, [configData])

  const onGetConfig = () => {
    const req: GetConfigReq = {
      config: key,
    }
    dispatch(getConfigAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  const onUpdateConfig = () => {
    const configValue = {
      enableName: isEnableName,
      enablePrice: isEnablePrice,
      enableUom: isEnableUom,
      paperType: paperType,
    }
    const req: SetConfigReq = {
      config_name: key,
      config_type: 'string',
      config_value: JSON.stringify(configValue),
    }
    dispatch(setConfigAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onUpdateSuccess = (): void => {
    clearEvent()
    onGetConfig()
  }

  const renderNameStatus = () => {
    return (
      <Row justify="start">
        <Col md={24} xs={24}>
          <SwitchStyled>
            <Switch checked={isEnableName} onChange={setIsEnableName} />
            &nbsp; &nbsp; {isEnableName ? 'แสดงชื่อสินค้า' : 'ไม่แสดงชื่อสินค้า'}
          </SwitchStyled>
        </Col>
      </Row>
    )
  }

  const renderPriceStatus = () => {
    return (
      <Row justify="start">
        <Col md={24} xs={24}>
          <SwitchStyled>
            <Switch checked={isEnablePrice} onChange={setIsEnablePrice} />
            &nbsp; &nbsp; {isEnablePrice ? 'แสดงราคาสินค้า' : 'ไม่แสดงราคาสินค้า'}
          </SwitchStyled>
        </Col>
      </Row>
    )
  }

  const renderUomStatus = () => {
    return (
      <Row justify="start">
        <Col md={24} xs={24}>
          <SwitchStyled>
            <Switch checked={isEnableUom} onChange={setIsEnableUom} />
            &nbsp; &nbsp; {isEnableUom ? 'แสดงหน่วยสินค้า' : 'ไม่แสดงหน่วยสินค้า'}
          </SwitchStyled>
        </Col>
      </Row>
    )
  }

  const renderPayperType = () => {
    return (
      <Radio.Group onChange={e => setPaperType(e.target.value)} value={paperType}>
        <Space direction="vertical">
          {menuPaperSize.map(item => {
            return (
              <Radio value={item.value} key={item.value}>
                {item.name}
              </Radio>
            )
          })}
        </Space>
      </Radio.Group>
    )
  }

  return (
    <>
      <Row gutter={[32, 24]}>
        <Col md={12} xs={24}>
          <Row>
            <Col span={24}>
              <Title>เลือกรูปแบบสติ้กเกอร์พิมพ์สลากบาร์โค้ด</Title>
            </Col>
            <Col md={24} xs={24}>
              {renderPayperType()}
            </Col>
            <Divider />
            <Col span={24}>
              <Title>ตั้งค่าการพิมพ์บาร์โค้ด</Title>
            </Col>
            <Col md={24} xs={24}>
              {renderNameStatus()}
            </Col>
            <Col md={24} xs={24}>
              {renderPriceStatus()}
            </Col>
            <Col md={24} xs={24}>
              {renderUomStatus()}
            </Col>
            <Col md={24} xs={24}>
              <br />
              <br />
              <br />
              <Space size="middle" align="baseline">
                <PrimaryButton text="บันทึกข้อมูล" onClick={onUpdateConfig} />
              </Space>
            </Col>
          </Row>
        </Col>
      </Row>

      <EventModal
        event={[actionEvent]}
        enable={true}
        successCalback={onUpdateSuccess}
        errorCalback={clearEvent}
      />
      <LoadingView isShow={event.IsLoading} />
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    actionEvent: selectConfigActionEvent(state),
    event: selectConfigEvent(state),
    configData: selectConfig(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const Title = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.medium};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  margin-bottom: 10px;
`

const SwitchStyled = styled.div`
  margin: 10px 0;
`

const PositionStyled = styled.div`
  //margin-left: 60px;
  margin-top: 10px;
`

export default connect(mapStateToProps)(BarcodeConfig)
